module.exports = __webpack_public_path__ + "static/media/reports.6ec10daa.md";